import HomepageContainer from "containers/landing/homepage-container";
function Landing() {

  return (
    <HomepageContainer />
  )
}
export default Landing